export default "__VITE_ASSET__xa6npQbY__"